import { GMDialog } from '..';
import { useLocalization } from '../../../context/Localization/localization';
import { GMButton } from '../../Button';
import { DialogYesNoProps } from './DialogYesNo.types';

/**
 * A Dialog component that presents the user with a yes/no option.
 *
 * @param ariaLabel - {@link DialogYesNoProps.ariaLabel ariaLabel} description.
 * @param title - {@link DialogYesNoProps.title title} description.
 * @param open - {@link DialogYesNoProps.open open} description.
 * @param onYes - {@link DialogYesNoProps.onYes onYes} description.
 * @param onNo - {@link DialogYesNoProps.onNo onNo} description.
 * @param onYes - {@link DialogYesNoProps.yesText yesText} description.
 * @param onNo - {@link DialogYesNoProps.noText noText} description.
 * @param className - {@link DialogYesNoProps.className className} description.
 * @param paperDialogClasses - {@link DialogYesNoProps.paperDialogClasses paperDialogClasses} description.
 * @param children - {@link DialogYesNoProps.children children} description.
 */
const DialogYesNo = ({
    ariaLabel,
    title,
    className,
    paperDialogClasses,
    open,
    onYes,
    onNo,
    yesText,
    noText,
    children,
}: DialogYesNoProps) => {
    const Localization = useLocalization();
    const yesTextLabel = !!yesText ? yesText : Localization.Yes;
    const noTextLabel = !!noText ? noText : Localization.No;

    return (
        <GMDialog
            ariaLabel={ariaLabel}
            title={title}
            className={className}
            paperDialogClasses={paperDialogClasses}
            open={open}
            onClose={onNo}
            actions={[
                <GMButton
                    id={noTextLabel}
                    title={noTextLabel}
                    ariaLabel={noTextLabel}
                    onClick={onNo}
                    styleType={'secondary'}
                >
                    {noTextLabel}
                </GMButton>,
                <GMButton
                    id={yesTextLabel}
                    title={yesTextLabel}
                    ariaLabel={yesTextLabel}
                    onClick={onYes}
                    styleType={'primary'}
                >
                    {yesTextLabel}
                </GMButton>,
            ]}
        >
            {children}
        </GMDialog>
    );
};

export default DialogYesNo;